import buildSubjectApiPath from '@Application/Subjects/buildSubjectApiPath';
import type * as React from 'react';
import type { TranscriptPayload } from '@Application/Beneficiaries/Transcripts/Actions/transcriptFetched';
import transcriptReviewed, {
	type TranscriptReviewedAction,
} from '@Application/Beneficiaries/Transcripts/Actions/transcriptReviewed';
import transcriptReviewFailed, {
	type TranscriptReviewFailedAction,
} from '@Application/Beneficiaries/Transcripts/Actions/transcriptReviewFailed';
import type MarkTranscriptReviewed from '@Application/Beneficiaries/Transcripts/Commands/MarkTranscriptReviewed';
import { post } from '@Domain/Api';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';

type Actions = TranscriptReviewedAction | TranscriptReviewFailedAction;

export default (command: MarkTranscriptReviewed) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const payload = await post<TranscriptPayload>(
				`${buildSubjectApiPath(command.facilityId, command.subject)}/interviews/${command.interviewId}/transcript/reviews`,
				{},
			);

			const action = transcriptReviewed(payload, command.interviewId);
			dispatch(action);
			return action;
		} catch (error) {
			const action = transcriptReviewFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
